module.exports = __webpack_public_path__ + "static/media/students.9f421c93.png";